document.addEventListener('DOMContentLoaded', () => {
    const allTabs = document.querySelectorAll('a[data-toggle="tab"]');

    if (!allTabs) {
        return;
    }

    const onTabShown = () => {
        const ACTIVE_CLASS = 'active';

        allTabs.forEach((pageLink) => {
            pageLink.classList.remove(ACTIVE_CLASS);
            pageLink.setAttribute('aria-selected', 'false');
        });
    };

    allTabs.forEach((tab) => {
        tab.addEventListener('click', onTabShown);
    });
});
